import { render, staticRenderFns } from "./PurchaseContainer.vue?vue&type=template&id=de417fb8&"
import script from "./PurchaseContainer.vue?vue&type=script&lang=js&"
export * from "./PurchaseContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports